module.exports = __webpack_public_path__ + "static/img/automationBanner.ed728bc3.png";